import {createReducer} from '../utility'




export const provinces = createReducer({},{
    "FETCH_PROVINCE_SUCCESSFUL"(state, {data}){
        if(data){
            return {
                ...state,
                province: data
            }
        }else{
            return{
                ...state
            }
        }
    } 
})

export const districts = createReducer({},{
    "FETCH_DISTRICTS_SUCCESSFUL"(state, {data}){
        if(data){
            return {
                ...state,
                district: data
            }
        }else{
            return{
                ...state
            }
        }
    } 
})



export const sectors = createReducer({},{
    "FETCH_SECTORS_SUCCESSFUL"(state, {data}){
        if(data){
            return {
                ...state,
                sector: data
            }
        }else{
            return{
                ...state
            }
        }
    } 
})


export const cells = createReducer({},{
    "FETCH_CELLS_SUCCESSFUL"(state, {data}){
        if(data){
            return {
                ...state,
                cell: data
            }
        }else{
            return{
                ...state
            }
        }
    } 
})


export const villages = createReducer({},{
    "FETCH_VILLAGES_SUCCESSFUL"(state, {data}){
        if(data){
            return {
                ...state,
                village: data
            }
        }else{
            return{
                ...state
            }
        }
    } 
})